import yup from '#schema/locale';

export const profilePublicDetailsSchema = yup.object({
  loading: yup.boolean(),
  data: yup.object({
    attributes: yup.object({
      id: yup.string(),
      title: yup.string(),
      description: yup.string(),
      offers: yup.string(),
      profileUrl: yup.string(),
      avatarUrlMedium: yup.string(),
      avatarUrlFull: yup.string(),
      headerUrlMedium: yup.string(),
      headerUrlFull: yup.string(),
    }),
  }),
});
